import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Field } from 'formik'

import DownloadEplPdfLink from './DownloadEplPdfLink'
import RichTextEditor from '@components/Form/RichTextEditor'

import ToggleVisibility from './ToggleVisibility'
const ScreeningSection = ({
  staticData,
  form,
  epl,
  fieldHiddenToExpert,
  toggleFieldsHiddenToExpert
}) => {
  const { REPLY_STATUSES } = staticData.CONST
  const downloadLink =
    epl.epl.replyStatusId !== REPLY_STATUSES.APPLIED ? (
      <DownloadEplPdfLink epl={epl} />
    ) : null

  return (
    <div className='expert-form__section'>
      <h2 className='expert-form__subtitle'>Screening</h2>
      <div className='field-toggle-group'>
        {downloadLink}
        <Field
          name='screening'
          placeholder='Screening'
          toolbarRight
          skipWrapper
          form={form}
          component={RichTextEditor}
        />
        <ToggleVisibility
          invisible={fieldHiddenToExpert}
          cyData={'toggle-hide-screening'}
          onToggle={toggleFieldsHiddenToExpert}
        />
      </div>
    </div>
  )
}

ScreeningSection.propTypes = {
  epl: PropTypes.object,
  form: PropTypes.object,
  staticData: PropTypes.object,
  toggleFieldsHiddenToExpert: PropTypes.func,
  fieldHiddenToExpert: PropTypes.bool
}

export default observer(ScreeningSection)
